<script setup lang="ts">
import BoNoticeDocVarField from './BoNoticeDocVarField.vue';
import BoLetterHead from './parts/BoLetterHead.vue';
import BoLetterClose from './parts/BoLetterClose.vue';
</script>

<template>
  <div class="bo-doc">
    <BoLetterHead recipient-mode="corporate_member" />
    <p class="doc-p">
      <BoNoticeDocVarField field-key="company_name" />
      (Company Registration No. <BoNoticeDocVarField field-key="company_registration_no" />)
    </p>
    <p class="doc-p">
      Pursuant to subsection 60C(1) of the CA 2016, as a member of the Company you are required to inform and
      confirm who are the beneficial owner of the Company within 30 days from the date of this notice
      (please proceed to Appendix B for your reply).
    </p>
    <p class="doc-p">
      <b>2</b><br />
      You are required to indicate the persons by name and particulars sufficient to enable those persons to be
      identified as beneficial owner(s) of the Company.
    </p>
    <p class="doc-p">
      <b>3</b><br />
      If you have taken all reasonable measures to identify the beneficial owner and arrived at the following
      conclusion, please proceed to Appendix C as you are required to provide the information of senior management
      in place of the beneficial owner:
    </p>
    <p class="doc-p" style="padding-left:16px">
      The Company has no beneficial owner (please provide the name of the senior management of the Company);<br /><br />
      The beneficial owner of the Company cannot be identified (please provide the name of the senior management of the Company); or<br /><br />
      The Company is still in the process of obtaining the beneficial ownership information (please provide the name of the senior management of the Company).
    </p>
    <p class="doc-p"><b>4</b><br />Please include the following declaration as part of your reply:</p>
    <p class="doc-p" style="padding-left:16px; font-style:italic">
      “I/We hereby confirmed that the facts and information stated in this letter are true and to the best of my/our knowledge and belief.”
    </p>
    <p class="doc-p">
      <b>5</b><br />
      Please be informed that any person who fails to comply with this notice commits an offence under subsection
      60C(7) of the CA 2016 and/or provides false or misleading information commits an offence under section 593 of
      the CA 2016.
    </p>
    <BoLetterClose var-key="BO01" designation-key="signer_designation_BO01" />
  </div>
</template>

<style src="./boNoticeDoc.css"></style>
